import { createFileRoute } from '@tanstack/react-router'
import { useReport } from '@/hooks/use-report'
import { useDeferredValue } from 'react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { BoardPending } from './-components/shared/board-pending'
import { Board } from './-components/shared/board'
import { EmptyState } from './-components/shared/empty-state'
import { GroupContextProvider } from './-components/shared/group-context'

export const Route = createFileRoute('/_app/jobs/_list/$jobId/board')({
  component: RouteComponent,
  pendingComponent: BoardPending,
  // Painted on the click frame (router defaultPendingMs 0): at the library's 1000ms a navigation whose loaders
  // resolve inside a second rendered NOTHING new, and on a phone the NAV STACK could not push — the level it would
  // push is the route being rendered (see useRenderedPathname), still the old one. Measured on a device as "tapping
  // an integrant only marks it selected; the report never opens". A cached navigation costs at most one frame of it.
})

function RouteComponent() {
  const context = Route.useRouteContext()
  const { report } = useReport(context.reportQueryOptions)
  // Deferred so changing the type filter keeps the PREVIOUS view on screen while the new data loads —
  // the options object comes from the route's context, so this is the very object the loader warmed.
  const deferredIntegrants = useDeferredValue(context.jobIntegrantIndicatorsQueryOptions)
  const { data: jobIntegrants } = useSuspenseQuery(deferredIntegrants)
  const { data: job } = useSuspenseQuery(context.jobQueryOptions)

  const members = (jobIntegrants?.members ?? []).map((member) => ({
    ...member,
    id: member.id,
  }))

  if (jobIntegrants?.emptyStateCode) {
    return <EmptyState code={jobIntegrants.emptyStateCode} surface="board" />
  }

  return (
    <GroupContextProvider type="job">
      <Board report={report} name={job.name ?? ''} profiles={members} standardIndicators={jobIntegrants?.indicators} />
    </GroupContextProvider>
  )
}
